import Vue from 'vue'
import App from './App.vue'
import './assets/tailwind.css'
import './assets/globals.css'
import '@fortawesome/fontawesome-free/js/all.js'
import router from './router'
import store from './store'
import './filter/filter.js'
import './permission.js'
import vClickOutside from 'v-click-outside'
Vue.config.productionTip = false
import VueRx from "vue-rx"; Vue.use(VueRx);
Vue.use(vClickOutside)
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')